'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { DSA_APPEAL_EDUCATION_URL } from '../../constants/routes'

type Props = ConversationActionProps

const AppealTheDecision = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()

  if (!conversation?.id) return null

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={DSA_APPEAL_EDUCATION_URL(Number(conversation.id))}
      testId="appeal-the-decision-conversation-action"
    />
  )
}

export default AppealTheDecision
